module.exports = __webpack_public_path__ + "img/KK0043C-GL.19a833a9.jpg";